let questionnaire = {
  getAnswerList() {
    return `/api/expandAnswer/getQuestions/`
  },
  answerQuestions() {
    return `/api/expandAnswer/answerQuestions`
  },
  getQuestionInfo() {
    return `/api/expandAnswer/getMyAnswer`
  },
  unlimitedAnswerQuestions() {
    return `/api/expandAnswer/submitMyAnswer`
  },
  // 是否回答问题
  answerIsExist() {
    return `/api/expandAnswer/myAnswerExists`
  }
  
}
export default questionnaire
